const RECENT_SEARCHES_KEY = 'plutoo_recent_searches';
const MAX_RECENT = 6;
const MAX_PAGE_SUGGESTIONS = 8;

const POPULAR_PAGE_PATHS = [
  '/dashboard',
  '/properties',
  '/tenants',
  '/maintenance',
  '/calendar',
  '/settings',
];

export function getRecentSearches() {
  try {
    const raw = localStorage.getItem(RECENT_SEARCHES_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((t) => typeof t === 'string' && t.trim()) : [];
  } catch {
    return [];
  }
}

export function addRecentSearch(term) {
  const trimmed = typeof term === 'string' ? term.trim() : '';
  if (!trimmed || trimmed.length < 2) return;
  try {
    const existing = getRecentSearches().filter((t) => t.toLowerCase() !== trimmed.toLowerCase());
    const next = [trimmed, ...existing].slice(0, MAX_RECENT);
    localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(next));
  } catch {
    // ignore quota / private mode
  }
}

function matchesQuery(text, query) {
  if (!text || !query) return false;
  return text.toLowerCase().includes(query.toLowerCase());
}

function pageToSuggestionItem(page) {
  return {
    id: `page-${page.path}`,
    title: page.title,
    path: page.path,
    icon: page.icon,
  };
}

/**
 * Build suggestion groups for global search when query is empty or shorter than full search threshold.
 */
export function buildAutoSuggestionResults({ query, accessiblePages, recentSearches = [] }) {
  const trimmed = (query || '').trim();
  const lower = trimmed.toLowerCase();
  const groups = [];

  if (!trimmed && recentSearches.length > 0) {
    groups.push({
      category: 'recent',
      items: recentSearches.slice(0, MAX_RECENT).map((term) => ({
        id: `recent-${term}`,
        title: term,
        subtitle: 'Recent search',
        query: term,
      })),
    });
  }

  let pageCandidates = accessiblePages || [];

  if (!trimmed) {
    const popular = POPULAR_PAGE_PATHS.map((path) => pageCandidates.find((p) => p.path === path)).filter(Boolean);
    const rest = pageCandidates.filter((p) => !POPULAR_PAGE_PATHS.includes(p.path));
    pageCandidates = [...popular, ...rest].slice(0, MAX_PAGE_SUGGESTIONS);
  } else {
    pageCandidates = pageCandidates
      .filter(
        (page) =>
          matchesQuery(page.title, lower) ||
          matchesQuery(page.path, lower) ||
          matchesQuery(page.pageName, lower)
      )
      .slice(0, MAX_PAGE_SUGGESTIONS);
  }

  if (pageCandidates.length > 0) {
    groups.push({
      category: 'pages',
      items: pageCandidates.map(pageToSuggestionItem),
    });
  }

  return groups;
}
